$(document).on('click', '.accordion-tabs li.tab', function(){
  $(".accordion-tabs li.tab").removeClass("active");
  $(this).addClass("active");
  
  var target = $(this).data("target");
  $(".accordion").removeClass("active");
  $("."+target).addClass("active"); 
});

    setTimeout(() => {
          // Step 1: Query the section element
        const iframe1 = document.querySelector('iframe[title="widget_xcomponent"]');
        let targetElement;
        let iframeDoc;
            if (iframe1) {
               iframeDoc = iframe1.contentDocument || iframe1.contentWindow.document;
               targetElement = iframeDoc.querySelector('section.sc-cPiKLX.jJWGPZ');
                console.log(targetElement);
            }
      
          // Step 2: Find the parent container
          let parentContainer = iframeDoc.querySelector('.sub-panel.inline');
      
          if (targetElement && parentContainer) {
              // Step 3: Find the child inside the parent
              let childElement = parentContainer.querySelector('.relative.text-center');
      
              if (childElement) {
                  // Step 4: Append the element inside the child
                  childElement.appendChild(targetElement);
                  console.log("Element successfully moved after 3 seconds!");
              } else {
                  console.log("Child element (.relative.text-center) not found!");
              }
          } else {
              console.log("Target element or parent container not found!");
          }
      }, 50000);